const Slider = function (settings) {

    const default_settings = {
        wrapper: ".slider-wrapper",
        maxHeight: "70vh",
        dots: true,
        arrows: true,
        autoStart: true,
        duration: 5000,
        slidesPerView: 1,
        nthSlideVisible: (index, slide) => {},
    };

    parseOptions(default_settings, settings);

    let wrapper = $(default_settings.wrapper);
    let slidesWrap = wrapper.find(".slider-slides");
    let slides = slidesWrap.find(".slider-slide");
    let count = slides.length;
    let prevBtn = wrapper.find(".slider-prev");
    let nextBtn = wrapper.find(".slider-next");
    let activeView = 1;
    let slidesPerSlideNum = 1;
    let timer = null;

    // check views texts
    let sliderViewsTexts = wrapper.find(".slider-views-texts");
    let sliderViewsRules = [];

    if(isDefined(sliderViewsTexts)){
        sliderViewsTexts.find(".slider-view-text").each(function (index) {

            sliderViewsRules[index] = {};

            if(isDefined($(this).data("views"))){
                sliderViewsRules[index].default = $.map($(this).data("views").toString().split(','), function(value){
                    return parseInt(value, 10);
                });
            }
            if(isDefined($(this).data("desktop-views"))){
                sliderViewsRules[index].desktop = $.map($(this).data("desktop-views").toString().split(','), function(value){
                    return parseInt(value, 10);
                });
            }
            if(isDefined($(this).data("tablet-views"))){
                sliderViewsRules[index].tablet = $.map($(this).data("tablet-views").toString().split(','), function(value){
                    return parseInt(value, 10);
                });
            }
            if(isDefined($(this).data("mobile-views"))){
                sliderViewsRules[index].mobile = $.map($(this).data("mobile-views").toString().split(','), function(value){
                    return parseInt(value, 10);
                });
            }

        });
    }

    const getTranslate = function () {
        let translate = slidesWrap.css("transform").split(/[()]/)[1];
        return parseInt(translate.split(',')[4]);
    };

    const setTranslate = function (translate) {
        slidesWrap.css("transform", "translateX(" + translate + "px)");
    };

    const checkArrows = function () {
        if (activeView === 1) {
            prevBtn.hide();
        } else {
            prevBtn.show();
        }
        if (activeView * slidesPerSlideNum < count) {
            nextBtn.show();
        } else {
            nextBtn.hide();
        }
    };

    const slidesLoaded = function (num) {
        for (let i = 0; i < num; i++) {
            default_settings.nthSlideVisible((activeView * num) + i, slidesWrap.find(".slider-slide").eq(((activeView - 1) * num) + i));
        }
    };

    const moveToSlide = function (index) {

        if (((index * slidesPerSlideNum) > count && (index - 1) * slidesPerSlideNum >= count) || (index * slidesPerSlideNum) < 0) {
            return false;
        }

        let slideWidth = slides.first().outerWidth() * slidesPerSlideNum;
        setTranslate(-1 * (slideWidth * (index - 1)));
        activeView = index;

        setTimeout(function () {
            slidesLoaded(slidesPerSlideNum);
        }, 1000);

        checkArrows();

        if(isDefined(sliderViewsTexts)){

            let activeSliderViewTextIndex = null;

            for(const [i,v] of sliderViewsRules.entries()) {

                if ($(window).width() <= 480) {
                    if (isDefined(v.mobile) && v.mobile.includes(activeView)) {
                        activeSliderViewTextIndex = i;
                        break;
                    } else {
                        if(v.default.includes(activeView)) {
                            activeSliderViewTextIndex = i;
                            break;
                        }
                    }
                } else if ($(window).width() <= 768) {
                    if (isDefined(v.tablet) && v.tablet.includes(activeView)) {
                        activeSliderViewTextIndex = i;
                        break;
                    } else {
                        if(v.default.includes(activeView)) {
                            activeSliderViewTextIndex = i;
                            break;
                        }
                    }
                } else {
                    if (isDefined(v.desktop) && v.desktop.includes(activeView)) {
                        activeSliderViewTextIndex = i;
                        break;
                    } else {
                        if(v.default.includes(activeView)) {
                            activeSliderViewTextIndex = i;
                            break;
                        }
                    }
                }

            }

            sliderViewsTexts.find(".slider-view-text").removeClass('active').eq(activeSliderViewTextIndex).addClass("active");

        }

        if (wrapper.find(".slider-pagination").length) {
            wrapper.find(".slider-pagination li a").removeClass("active");
            wrapper.find(".slider-pagination").find("li").eq(index - 1).find("a").addClass("active");
        }

        return true;

    };

    const startTimer = function () {
        let newRepeat = false;
        timer = setInterval(() => {
            let result = true;
            if (newRepeat) {
                newRepeat = false;
                result = moveToSlide(activeView);
            } else {
                result = moveToSlide(activeView + 1);
            }
            if(!result){
                activeView = 1;
                moveToSlide(activeView);
            }
            if (activeView * slidesPerSlideNum >= count) {
                activeView = 1;
                newRepeat = true;
            }
        }, default_settings.duration);
    };

    const clearTimer = function () {
        clearInterval(timer);
        startTimer();
    };

    const setSizes = function () {

        if (typeof default_settings.slidesPerView === "object") {

            if ($(window).width() <= 716) {
                slides.css({"flex-basis": "" + (100 / default_settings.slidesPerView.mobile) + "%"});
            } else if ($(window).width() <= 768) {
                slides.css({"flex-basis": "" + (100 / default_settings.slidesPerView.tablet) + "%"});
            } else {
                slides.css({"flex-basis": "" + (100 / default_settings.slidesPerView.desktop) + "%"});
            }

        } else {

            if (typeof default_settings.slidesPerView === "string") {
                let match = default_settings.slidesPerView.match(/auto-fill\((.*)\)/);
                if (match) {

                    let width = parseInt(match[1]);
                    let units = match[1].replace(width, "");

                    slides.css({"flex-basis": "" + width + units + ""});

                    let slideWidth = slides.first().outerWidth();
                    let fitCount = Math.floor(wrapper.outerWidth() / slideWidth);
                    if (fitCount > count) fitCount = count;

                    let widthRest = wrapper.outerWidth() - (fitCount * slideWidth);
                    slides.css({"flex-basis": "" + (parseInt(match[1]) + widthRest / fitCount) + units + ""});
                }
            } else {
                if (default_settings.slidesPerView > 0) {
                    slides.css({"flex-basis": "" + (100 / default_settings.slidesPerView) + "%"});
                }
            }

        }

        slidesPerSlideNum = Math.floor(wrapper.outerWidth() / slides.first().outerWidth());

    };

    wrapper.css("max-height", default_settings.maxHeight);
    setSizes();
    slidesLoaded();

    if (default_settings.arrows) {

        if (count >= 2) nextBtn.show();

        prevBtn.on("click", function (e) {
            e.preventDefault();
            moveToSlide(activeView - 1);
            if (default_settings.autoStart) {
                clearTimer();
            }
        });

        nextBtn.on("click", function (e) {
            e.preventDefault();
            moveToSlide(activeView + 1);
            if (default_settings.autoStart) {
                clearTimer();
            }
        });
    }

    if (default_settings.dots) {
        wrapper.append(`<div class="slider-pagination-wrap"><ul class="slider-pagination"></ul></div>`);
        let pagination = wrapper.find(".slider-pagination");
        let j = 1;
        for (let i = 1; i <= count; i += slidesPerSlideNum) {
            pagination.append(`<li><a href="#" ${i === 1 ? 'class="active"' : ""} data-slide="${j}">${j}</a></li>`);
            j++;
        }
        $(pagination).on("click", "a", function (e) {
            e.preventDefault();
            moveToSlide($(this).data("slide"));
            $(this).addClass("active");
            $(this).parent().siblings().find("a").removeClass("active");
            if (default_settings.autoStart) {
                clearTimer();
            }
        });
    }

    if (default_settings.autoStart) {
        startTimer();
    }

    /*wrapper.on("mouseover", function () {
        wrapper.attr("tabindex", -1).trigger("focus");
    });*/

    wrapper.on("mouseleave", function () {
        wrapper.trigger("blur");
    });

    wrapper.on("keydown", function (e) {
        let code = e.which;
        if (code === 39) {
            moveToSlide(activeView + 1);
            clearTimer();
        }
        if (code === 37) {
            moveToSlide(activeView - 1);
            clearTimer();
        }
    });

    $(window).on("resize", function () {
        setSizes();
        moveToSlide(activeView);
    });

    /*wrapper.dragDetect({
        itemsClass: slidesWrap.attr("class"),
        dragMove: function () {
            if (default_settings.autoStart) clearTimer();
        },
        dragEnd: function (info) {
            if (info.clientX > info.startMove.clientX) {
                moveToSlide(activeView - 1);
            } else if (info.startMove.clientX > info.clientX) {
                moveToSlide(activeView + 1);
            }
        }
    });*/

};